import React, { useState } from "react";
import {
  Container,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  Typography,
  CardMedia,
} from "@mui/material";
// import { PlayCircleOutline } from "@mui/icons-material";
import { Box, styled } from "@mui/system";

const CustomTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "#ff4081",
    height: "4px",
    borderRadius: "2px",
  },
});

const CustomTab = styled(Tab)({
  textTransform: "none",
  fontSize: "16px",
  fontWeight: "bold",
  color: "#666",
  transition: "color 0.3s ease",
  "&.Mui-selected": {
    color: "#ff4081",
  },
  "&:hover": {
    color: "#ff4081",
  },
});
const videos = [
  {
    title: "Hon’ble CM Message",
    url: "https://www.youtube.com/embed/mnCXb3mxhXo?si=Il7txu1Bb-hrdfEM",
  },
  {
    title: "Naan Mudhalvan Scheme - Portal Launch",
    url: "https://www.youtube.com/embed/NbLeNM1wX-o?si=lAMD-jENa2sN5VKR",
  },
];

const podcasts = [
  {
    title: "Podcast Episode 1",
    url: "https://onlinetestcase.com/wp-content/uploads/2023/06/100-KB-MP3.mp3",
  },
  {
    title: "Podcast Episode 2",
    url: "https://onlinetestcase.com/wp-content/uploads/2023/06/500-KB-MP3.mp3",
  },
];

const WatchListen = () => {
  const [tabIndex, setTabIndex] = useState(0);
  return (
    <Box id="watch-listen" sx={{ my: 4 }}>
      <Container>
        <Typography variant="h4" align="center" gutterBottom>
          Watch/Listen
        </Typography>
        <Box
          sx={{ width: "100%", display: "flex", justifyContent: "left", mt: 2 }}
        >
          <CustomTabs
            value={tabIndex}
            onChange={(e, newIndex) => setTabIndex(newIndex)}
            centered
          >
            <CustomTab label="Videos" />
            <CustomTab label="Podcasts" />
          </CustomTabs>
        </Box>

        {tabIndex === 0 && (
          <Grid container spacing={2} mt={2}>
            {videos.map((video, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card>
                  <CardMedia
                    component="iframe"
                    height="300"
                    src={video.url}
                    title={video.title}
                  />
                  <CardContent>
                    <Typography variant="h6">{video.title}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        {tabIndex === 1 && (
          <Grid container spacing={2} mt={2}>
            {podcasts.map((podcast, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">{podcast.title}</Typography>
                    <audio controls style={{ width: "100%" }}>
                      <source src={podcast.url} type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default WatchListen;
